import { KeenIcon } from '@/components';

/**
 * AI Features settings card. Persists the firm-wide `ai_features_enabled`
 * global setting, which gates Aila's AI case summaries on contact and matter
 * pages. A missing key counts as ON — the backend treats it the same way.
 *
 * The settings endpoint requires the firm's core fields on every save, so the
 * toggle resends them unchanged alongside the flag (same idea as Preferences).
 */
const AdvancedSettingsAiFeatures = ({ data, onConfirm, loadData, loadDataSave }) => {
  const enabled = data ? data.ai_features_enabled !== false : false;
  const busy = loadData || loadDataSave || !data;

  const handleToggle = () => {
    if (busy) return;

    const formData = new FormData();
    formData.append('legal_business_name', data.legal_business_name ?? '');
    formData.append('country', data.country ?? '');
    formData.append('date_format', data.date_format ?? '');
    formData.append('time_format', data.time_format ?? '');
    formData.append('ai_features_enabled', enabled ? '0' : '1');
    formData.append('_method', 'PUT');
    onConfirm(formData);
  };

  return (
    <div className="card">
      <div className="card-header" id="advanced_settings_ai">
        <h3 className="card-title">AI Features</h3>
        <span className={`badge badge-sm badge-outline ${enabled ? 'badge-success' : ''}`}>
          {enabled ? 'Active' : 'Off'}
        </span>
      </div>
      <div className="card-body lg:py-7.5">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-start gap-3">
            <KeenIcon icon="technology-2" className="text-lg text-primary mt-0.5" />
            <div className="flex flex-col gap-1">
              <span className="text-sm font-medium text-gray-900">Enable AILA</span>
              <span className="text-xs text-gray-500 max-w-[520px]">
                Turn AILA on or off for your firm — the AI assistant that
                summarizes what&apos;s going on in each contact and matter,
                with upcoming due dates front and center.
              </span>
            </div>
          </div>

          <label className="switch shrink-0">
            <input
              type="checkbox"
              checked={enabled}
              onChange={handleToggle}
              disabled={busy}
              aria-label="Enable AI features"
            />
          </label>
        </div>
      </div>
    </div>
  );
};

export { AdvancedSettingsAiFeatures };
